(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-article-template"]) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('.cf-article-reading').forEach(root => {
    root.querySelectorAll('.article__body h2, .article__body h3').forEach(heading => {
      if (!/^(häufige fragen|faq)(\s|$)/i.test(heading.textContent.trim())) return;
      let paragraph = heading.nextElementSibling;
      while (paragraph && paragraph.tagName === 'P') {
        const question = paragraph.firstElementChild;
        if (!question || question.tagName !== 'STRONG' || question.nextElementSibling?.tagName !== 'BR') break;
        const next = paragraph.nextElementSibling;
        const details = document.createElement('details');
        details.className = 'cf-article-faq';
        const summary = document.createElement('summary');
        summary.textContent = question.textContent.trim();
        const answer = document.createElement('div');
        answer.className = 'cf-article-faq__answer';
        const content = paragraph.cloneNode(true);
        content.querySelector('strong').remove();
        content.querySelector('br').remove();
        answer.append(content);
        details.append(summary,answer);
        paragraph.replaceWith(details);
        paragraph = next;
      }
    });
    root.querySelectorAll('.article__body > p').forEach(paragraph => {
      if (paragraph.classList.contains('cf-article-note')) return;
      const text = paragraph.textContent.trim();
      const match = text.match(/^(Philips Tipp|Mein Tipp|Anreisehinweis|Buchungshinweis|Vor deinem Besuch)\s*:/i);
      if (!match) return;
      paragraph.classList.add('cf-article-note');
      if (/Anreise/i.test(match[1])) paragraph.classList.add('cf-article-note--travel_note');
      if (/Buchung|Besuch/i.test(match[1])) paragraph.classList.add('cf-article-note--booking_note');
    });
    const toc = root.querySelector('.cf-article-toc');
    if (!toc || toc.dataset.ready) return;
    const body = root.querySelector('.article__body');
    const headings = [...body.querySelectorAll('h2,h3')].filter(h => !h.closest('nav,.cf-article-inline-product'));
    if (headings.filter(h => h.tagName === 'H2').length < 2) return;
    toc.dataset.ready = 'true';
    const list = toc.querySelector('ol');
    let parentItem;
    const links = new Map();
    headings.forEach((heading,index) => {
      if (!heading.id) {
        let id = 'cf-article-heading-' + index;
        while (document.getElementById(id)) id += '-chapter';
        heading.id = id;
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + encodeURIComponent(heading.id);
      link.textContent = heading.textContent.trim();
      item.append(link);
      links.set(heading,link);
      if (heading.tagName === 'H3' && parentItem) {
        let sublist = parentItem.querySelector('ol');
        if (!sublist) { sublist = document.createElement('ol'); sublist.setAttribute('role','list'); parentItem.append(sublist); }
        sublist.append(item);
      } else {
        list.append(item);
        if (heading.tagName === 'H2') parentItem = item;
      }
    });
    body.querySelectorAll('nav[aria-label="Inhaltsverzeichnis"]').forEach(nav => nav.dataset.cfReplacedToc = 'true');
    toc.hidden = false;
    const desktop = window.matchMedia('(min-width:1100px)');
    const tocSummary = toc.querySelector('summary');
    const setOpen = () => { toc.open = desktop.matches; };
    tocSummary.addEventListener('click', event => { if (desktop.matches) event.preventDefault(); });
    toc.addEventListener('toggle', () => { if (desktop.matches && !toc.open) toc.open = true; });
    setOpen();
    desktop.addEventListener('change',setOpen);
    const updateOffset = () => {
      const header = document.querySelector('#SiteHeader');
      const height = header ? header.getBoundingClientRect().height : 116;
      root.style.setProperty('--cf-article-offset', Math.ceil(height + 24) + 'px');
    };
    updateOffset();
    const header = document.querySelector('#SiteHeader');
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    const sidebar = toc.closest('.cf-article-sidebar');
    const fitToc = () => {
      const offset = parseFloat(getComputedStyle(root).getPropertyValue('--cf-article-offset')) || 140;
      sidebar.classList.toggle('cf-article-sidebar--tall', desktop.matches && sidebar.getBoundingClientRect().height + offset + 24 > window.innerHeight);
    };
    fitToc();
    window.addEventListener('resize', fitToc, {passive:true});
    if ('ResizeObserver' in window) {
      const tocSizeObserver = new ResizeObserver(fitToc);
      tocSizeObserver.observe(sidebar);
      if (header) tocSizeObserver.observe(header);
    }
    let clickedHeading = null;
    let settleTimer;
    let framePending = false;
    const markActive = heading => {
      links.forEach((link,item) => {
        if (item === heading) link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
    };
    const trackChapter = () => {
      framePending = false;
      if (!root.isConnected || clickedHeading) return;
      const offset = parseFloat(getComputedStyle(root).getPropertyValue('--cf-article-offset')) || 140;
      let current = headings[0];
      for (const heading of headings) {
        if (heading.getBoundingClientRect().top <= offset + 3) current = heading;
        else break;
      }
      markActive(current);
    };
    const releaseClick = () => { clickedHeading = null; trackChapter(); };
    const onScroll = () => {
      clearTimeout(settleTimer);
      if (clickedHeading) settleTimer = setTimeout(releaseClick,180);
      if (!framePending) { framePending = true; requestAnimationFrame(trackChapter); }
    };
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    window.addEventListener('wheel',releaseClick,{passive:true});
    window.addEventListener('touchstart',releaseClick,{passive:true});
    window.addEventListener('keydown',event => {
      if (['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(event.key)) releaseClick();
    });
    trackChapter();
    toc.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!target) return;
      event.preventDefault();
      clickedHeading = target;
      markActive(target);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(releaseClick,1500);
      target.closest('details')?.setAttribute('open','');
      target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      history.pushState(null,'',link.hash);
    });


  });
  initialize();
  document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-black-week"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const button=event.target.closest('[data-bw-filter]');
  if(!button)return;
  const root=button.closest('.cf-bw');
  const category=button.dataset.bwFilter;
  root.querySelectorAll('[data-bw-filter]').forEach(function(item){item.setAttribute('aria-pressed',item===button?'true':'false')});
  root.querySelectorAll('[data-bw-category]').forEach(function(item){item.hidden=category!=='all'&&!item.dataset.bwCategory.split(' ').includes(category)});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-frontcars"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.fcReady) return;
    root.dataset.fcReady = 'true';
    const container = root.querySelector('[data-fc-groups]');
    const form = root.querySelector('[data-fc-filters]');
    const park = form.elements.cf_park;
    const ride = form.elements.cf_ride;
    const parkDefault = park.options[0].text;
    const rideDefault = ride.options[0].text;
    const status = root.querySelector('[data-fc-status]');
    const loading = root.querySelector('[data-fc-loading]');
    const error = root.querySelector('[data-fc-error]');
    const pagination = root.querySelector('[data-fc-pagination]');
    let groups = [];
    let next = pagination.querySelector('[data-fc-next]')?.href;
    let busy = false;
    const ordered = values => [...new Set(values)].sort((a,b) => a.localeCompare(b,document.documentElement.lang || 'de'));
    const options = (select, values, label, value) => {
      select.replaceChildren(new Option(label,''), ...values.map(item => new Option(item,item)));
      select.value = values.includes(value) ? value : '';
    };
    const organize = () => {
      const merged = new Map();
      container.querySelectorAll('[data-fc-group]').forEach(group => {
        const key = group.dataset.fcPark + '\u0000' + group.dataset.fcRide;
        if (merged.has(key)) {
          merged.get(key).querySelector('.cf-frontcars__grid').append(...group.querySelectorAll('[data-fc-product]'));
          group.remove();
        } else merged.set(key,group);
      });
      const parks = new Map();
      [...merged.values()].sort((a,b) => {
        if (!a.dataset.fcDesign) return 1;
        if (!b.dataset.fcDesign) return -1;
        return a.dataset.fcPark.localeCompare(b.dataset.fcPark,'de') || a.dataset.fcRide.localeCompare(b.dataset.fcRide,'de');
      }).forEach(group => {
        const grid = group.querySelector('.cf-frontcars__grid');
        const seen = new Set();
        [...grid.children].sort((a,b) => Number(a.dataset.fcRank)-Number(b.dataset.fcRank)).forEach(card => {
          if (seen.has(card.dataset.fcProduct)) card.remove();
          else { seen.add(card.dataset.fcProduct); grid.append(card); }
        });
        const name = group.dataset.fcPark;
        if (!parks.has(name)) {
          const wrapper = document.createElement('section');
          wrapper.className = 'cf-frontcars__park';
          const heading = document.createElement('h2');
          heading.textContent = name;
          wrapper.append(heading);
          parks.set(name,wrapper);
        }
        parks.get(name).append(group);
      });
      container.replaceChildren(...parks.values());
      groups = [...container.querySelectorAll('[data-fc-group]')];
    };
    const apply = (write) => {
      let count = 0;
      groups.forEach(group => {
        group.hidden = !!((park.value && group.dataset.fcPark !== park.value) || (ride.value && group.dataset.fcRide !== ride.value));
        if (!group.hidden) count += group.querySelectorAll('[data-fc-product]').length;
      });
      container.querySelectorAll('.cf-frontcars__park').forEach(group => { group.hidden = ![...group.querySelectorAll('[data-fc-group]')].some(item => !item.hidden); });
      status.textContent = root.dataset.countLabel.replace('[count]',count);
      root.querySelector('[data-fc-empty]').hidden = count !== 0;
      if (write) {
        const url = new URL(location.href);
        [['cf_park',park.value],['cf_ride',ride.value]].forEach(([key,value]) => value ? url.searchParams.set(key,value) : url.searchParams.delete(key));
        if (root.dataset.previewThemeId) url.searchParams.set('preview_theme_id',root.dataset.previewThemeId);
        history.pushState(history.state,'',url);
      }
      window.dispatchEvent(new Event('resize'));
    };
    const rides = (value) => options(ride,ordered(groups.filter(group => !park.value || group.dataset.fcPark === park.value).map(group => group.dataset.fcRide)),rideDefault,value);
    const restore = () => {
      const url = new URL(location.href);
      options(park,ordered(groups.map(group => group.dataset.fcPark)),parkDefault,url.searchParams.get('cf_park'));
      rides(url.searchParams.get('cf_ride'));
      apply(false);
    };
    form.addEventListener('submit',event => event.preventDefault());
    park.addEventListener('change',() => { rides(''); apply(true); });
    ride.addEventListener('change',() => apply(true));
    form.addEventListener('reset',event => { event.preventDefault(); park.value=''; rides(''); apply(true); });
    window.addEventListener('popstate',() => { if (root.isConnected) restore(); });
    const loadAll = async () => {
      if (busy) return;
      busy = true;
      form.hidden = true;
      error.hidden = true;
      loading.hidden = !next;
      try {
        while (next) {
          const url = new URL(next,location.origin);
          if (root.dataset.previewThemeId) url.searchParams.set('preview_theme_id',root.dataset.previewThemeId);
          url.searchParams.set('section_id',root.dataset.sectionId);
          url.searchParams.set('view','cf-frontcars');
          const response = await fetch(url,{credentials:'same-origin'});
          if (!response.ok) throw new Error('Unable to load products');
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          const source = html.querySelector('[data-frontcars]');
          if (!source) throw new Error('Missing product section');
          root.append(...source.querySelectorAll('style[data-cf-grid-swatch-styles]'));
          container.append(...source.querySelectorAll('[data-fc-group]'));
          const nextLink = source.querySelector('[data-fc-next]');
          next = nextLink ? new URL(nextLink.getAttribute('href'),url).href : null;
          if (next) pagination.querySelector('[data-fc-next]').href = next;
        }
        organize();
        restore();
        form.hidden = false;
        pagination.hidden = true;
      } catch (exception) { error.hidden = false; }
      finally { busy = false; loading.hidden = true; }
    };
    root.querySelector('[data-fc-retry]').addEventListener('click',loadAll);
    loadAll();
  };
  document.querySelectorAll('[data-frontcars]').forEach(initialize);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-frontcars]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-gift-product"]) return;
  try {
    
  if (!customElements.get('cf-gift-product')) {
    customElements.define('cf-gift-product', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const init = () => this.init();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true,signal:this.abort.signal});
        else init();
      }
      disconnectedCallback() { this.abort?.abort(); }
      init() {
        const form = this.querySelector('.product-single__form');
        if (!form || form.dataset.cfGiftReady) return;
        form.dataset.cfGiftReady = 'true';
        if (window.theme?.AjaxProduct) new window.theme.AjaxProduct(form);
        const recipient = form.querySelector('recipient-form');
        const toggle = recipient?.querySelector('input[type="checkbox"]');
        const fields = recipient?.querySelectorAll('.field__input');
        const email = recipient?.querySelector('input[type="email"]');
        const name = recipient?.querySelector('input[autocomplete="name"]');
        const date = recipient?.querySelector('input[type="date"]');
        const syncRecipient = () => {
          if (!toggle) return;
          toggle.value = 'true';
          toggle.setAttribute('aria-expanded', String(toggle.checked));
          fields.forEach(field => field.disabled = !toggle.checked);
          email.required = toggle.checked;
          if (name) name.maxLength = 255;
          recipient.dataset.productVariantId = form.querySelector('[name="id"]').value;
        };
        if (date) {
          const format = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
          const today = new Date();
          const lastDay = new Date(today);
          lastDay.setDate(today.getDate()+90);
          date.min = format(today);
          date.max = format(lastDay);
        }
        toggle?.addEventListener('change',syncRecipient,{signal:this.abort.signal});
        syncRecipient();
        let revision = 0;
        this.addEventListener('shopify:product:select',async event => {
          if (!this.contains(event.target)) return;
          const current = ++revision;
          this.selecting = true;
          const button = form.querySelector('[data-add-to-cart]');
          if (button) button.disabled = true;
          try {
            await event.promise;
            await Promise.resolve();
            if (current !== revision) return;
            syncRecipient();
          } catch (error) {
            if (error.name !== 'AbortError') console.warn('Gift card selection failed',error);
          } finally {
            if (current === revision) {
              this.selecting = false;
              const selected = this.querySelector('[data-kit-selected-variant]');
              const variant = selected ? JSON.parse(selected.textContent || 'null') : null;
              const currentButton = form.querySelector('[data-add-to-cart]');
              if (currentButton) currentButton.disabled = !variant?.available;
            }
          }
        },{signal:this.abort.signal});
        form.addEventListener('submit',event => {
          if (this.selecting) { event.preventDefault(); event.stopImmediatePropagation(); }
        },{capture:true,signal:this.abort.signal});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["conversion-sidecart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('conversion-sidecart')) {
    class ConversionSidecart extends HTMLElement {
      constructor() {
        super();
        this.lastFocused = null;
        this.updating = false;
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        document.addEventListener('keydown', this.onKeydown);
        this.setupMobileLayout();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        this.mobileLayoutQuery?.removeEventListener('change', this.applyMobileLayout);
        this.footerObserver?.disconnect();
      }


      setupMobileLayout() {
        const body = this.querySelector('.cf-sidecart__body');
        const footer = this.querySelector('.cf-sidecart__footer');
        if (!body || !footer) return;
        const form = footer.querySelector('form');
        const checkout = form?.querySelector('[name="checkout"]');
        if (!form || !checkout) return;
        form.id = 'SidecartCheckout-' + this.dataset.sectionId;
        checkout.setAttribute('form', form.id);
        const details = document.createElement('details');
        details.className = 'cf-sidecart__mobile-details';
        const summary = document.createElement('summary');
        summary.textContent = footer.dataset.mobileDetailsLabel;
        details.append(summary);
        const nodes = Array.from(footer.children).filter(node =>
          node.matches('.cf-sidecart__cost-row, form, .cf-sidecart__continue, .cf-sidecart__trust')
        );
        const slots = nodes.map(node => {
          const marker = document.createComment('mobile-layout');
          node.before(marker);
          return { node, marker };
        });
        const buttonMarker = document.createComment('checkout-position');
        checkout.before(buttonMarker);
        this.mobileLayoutQuery = matchMedia('(max-width: 749px)');
        this.applyMobileLayout = () => {
          if (this.mobileLayoutQuery.matches) {
            slots.forEach(({ node }) => details.append(node));
            body.append(details);
            footer.append(checkout);
          } else {
            slots.forEach(({ node, marker }) => marker.after(node));
            buttonMarker.after(checkout);
            details.remove();
          }
        };
        this.mobileLayoutQuery.addEventListener('change', this.applyMobileLayout);
        this.applyMobileLayout();
        this.footerObserver = new ResizeObserver(() => {
          document.body.style.setProperty('--cf-sidecart-footer-height', Math.ceil(footer.getBoundingClientRect().height) + 'px');
        });
        this.footerObserver.observe(footer);
      }

      open() {
        this.lastFocused = document.activeElement;
        this.classList.add('is-open');
        document.body.classList.add('cf-sidecart-lock');
        requestAnimationFrame(() => this.querySelector('.cf-sidecart__panel')?.focus());
      }

      close() {
        this.classList.remove('is-open');
        document.body.classList.remove('cf-sidecart-lock');
        this.lastFocused?.focus?.();
      }

      setLoading(value) {
        this.updating = value;
        this.classList.toggle('is-loading', value);
        this.querySelector('.cf-sidecart__body')?.setAttribute('aria-busy', String(value));
        const pending = this.querySelector('.cf-sidecart__pending');
        if (pending) pending.hidden = !value;
      }

      showError(message) {
        const error = this.querySelector('.cf-sidecart__error');
        if (!error) return;
        error.textContent = message || '';
        error.hidden = !message;
        if (message) error.scrollIntoView({ block: 'nearest' });
      }

      replaceFromHtml(html, openAfter = true) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector('conversion-sidecart');
        if (!fresh) throw new Error('Warenkorb konnte nicht aktualisiert werden.');
        const wasOpen = this.classList.contains('is-open') || openAfter;
        this.replaceWith(fresh);
        if (wasOpen) fresh.open();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return fresh;
      }

      async refresh(openAfter = true) {
        const root = window.Shopify?.routes?.root || '/';
        const requests = [
          `${root}?section_id=${encodeURIComponent(this.dataset.sectionHandle)}`,
          `${window.location.pathname}?section_id=${encodeURIComponent(this.dataset.sectionId)}`
        ];
        let fresh = null;
        for (const url of requests) {
          try {
            const response = await fetch(url, { headers: { Accept: 'text/html' } });
            if (!response.ok) continue;
            const html = await response.text();
            if (html.includes('<conversion-sidecart')) {
              fresh = html;
              break;
            }
          } catch (error) {
            fresh = null;
          }
        }
        if (!fresh) throw new Error('Warenkorb konnte nicht aktualisiert werden.');
        this.replaceFromHtml(fresh, openAfter);
      }

      async changeLine(line, quantity) {
        if (this.updating) return;
        this.setLoading(true);
        this.showError('');
        try {
          const response = await fetch(this.dataset.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              line,
              quantity,
              sections: this.dataset.sectionId,
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message);
          const html = data.sections?.[this.dataset.sectionId] || data.sections?.[this.dataset.sectionHandle];
          if (html) this.replaceFromHtml(html, true);
          else await this.refresh(true);
        } catch (error) {
          this.setLoading(false);
          this.showError(error.message);
        }
      }

      async addVariant(id) {
        if (this.updating) return;
        this.setLoading(true);
        this.showError('');
        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(id), quantity: 1 }],
              sections: this.dataset.sectionId,
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message);
          const html = data.sections?.[this.dataset.sectionId] || data.sections?.[this.dataset.sectionHandle];
          if (html) this.replaceFromHtml(html, true);
          else await this.refresh(true);
        } catch (error) {
          this.setLoading(false);
          this.showError(error.message);
        }
      }

      onClick(event) {
        if (event.target.closest('[data-close]')) return this.close();
        const item = event.target.closest('[data-line]');
        if (event.target.closest('[data-remove]') && item) return this.changeLine(Number(item.dataset.line), 0);
        if (event.target.closest('[data-quantity-minus]') && item) {
          const input = item.querySelector('[data-quantity]');
          return this.changeLine(Number(item.dataset.line), Math.max(0, Number(input.value) - 1));
        }
        if (event.target.closest('[data-quantity-plus]') && item) {
          const input = item.querySelector('[data-quantity]');
          return this.changeLine(Number(item.dataset.line), Number(input.value) + 1);
        }
        const upsell = event.target.closest('[data-upsell-add]');
        if (upsell) this.addVariant(upsell.dataset.variantId);
      }

      onChange(event) {
        if (event.target.matches('[data-quantity]')) {
          const item = event.target.closest('[data-line]');
          this.changeLine(Number(item.dataset.line), Math.max(0, Number(event.target.value)));
        }
      }

      onKeydown(event) {
        if (!this.classList.contains('is-open')) return;
        if (event.key === 'Escape') this.close();
        if (event.key !== 'Tab') return;
        const focusable = [...this.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    }

    customElements.define('conversion-sidecart', ConversionSidecart);
  }

  if (!window.cfSidecartInitialized) {
    window.cfSidecartInitialized = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[href$="/cart"], [href*="/cart?"], [data-cart-drawer-trigger]');
      if (!trigger || trigger.closest('conversion-sidecart')) return;
      const drawer = document.querySelector('conversion-sidecart');
      if (!drawer) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      drawer.open();
    }, true);

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form || form.closest('conversion-sidecart')) return;
      const picker = form.closest('.product-section')?.querySelector('kit-variant-picker');
      const size = picker?.querySelector('[data-cf-size-option]');
      const missingSize = size && !size.querySelector('input:checked, option:checked:not([value=""])');
      if (missingSize || picker?.classList.contains('kit-picker--loading') || form.querySelector('[data-add-to-cart]')?.disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (missingSize) size.querySelector('input, select')?.focus();
        return;
      }
      const drawer = document.querySelector('conversion-sidecart');
      if (!drawer) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (drawer.updating) return;
      drawer.open();
      drawer.setLoading(true);
      drawer.showError('');
      try {
        const formData = new FormData(form);
        formData.set('sections', drawer.dataset.sectionId);
        formData.set('sections_url', window.location.pathname);
        const response = await fetch(drawer.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message);
        const html = data.sections?.[drawer.dataset.sectionId] || data.sections?.[drawer.dataset.sectionHandle];
        if (html) drawer.replaceFromHtml(html, true);
        else await drawer.refresh(true);
      } catch (error) {
        drawer.setLoading(false);
        drawer.showError(error.message);
      }
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
